import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { LuLock } from 'react-icons/lu';

const stylesheet = {
  root: 'mt-4 flex items-center justify-center gap-[7px] text-center text-[12.5px] font-medium text-semantic-text-tertiary text-pretty',
  icon: 'shrink-0 text-semantic-emerald',
};

export function AuthPasswordNote(): ReactNode {
  const { t } = useTranslation();
  return (
    <p className={stylesheet.root}>
      <LuLock className={stylesheet.icon} aria-hidden={true} />
      {t('auth.security.passwordNote')}
    </p>
  );
}
